export default __webpack_public_path__ + "media/music/75a9b839f980e0753820fb0350e04125.mp3";